import { cloneDeep, merge } from 'lodash'

import messages from '@sigma-frontend-libs/messages'

import notifications from './notifications'
import settingsUser from './settingsUser'

const granularCommonLabels = merge(cloneDeep(settingsUser.labels), {
  sendings: {
    phoneNumber: {
      checkMobile: 'Verificar número de teléfono móvil'
    }
  },

  billings: {
    autoAccrual: 'Recarga automática'
  },

  referral: {
    billings: {
      processedChildOperations: 'Procesar operaciones financieras del programa de referidos de usuarios secundarios'
    }
  },

  webhooks: 'Webhooks',

  notifications: {
    enabled: 'Notificaciones activadas',

    events: {
      billings: {
        limit: 'Notificación de umbral de saldo [OBSOLETO]'
      },

      tariff: {
        update: 'Notificación de actualización de tarifa'
      },

      balance: {
        limit: 'Notificación de umbral de saldo',
        accrual: 'Notificación de acreditación en el saldo',
        daily: 'Notificación diaria de saldo'
      },

      auth: {
        registration: 'Notificación de registro',
        recover: 'Notificación de recuperación de contraseña'
      },

      pattern: {
        approved: 'Notificación de aprobación de plantilla',
        rejected: 'Notificación de rechazo de plantilla'
      },

      sendername: {
        approved: 'Notificación de aprobación de nombre de remitente',
        rejected: 'Notificación de rechazo de nombre de remitente'
      },

      sendings: {
        bulk: {
          created: 'Notificación de creación de envío masivo',
          paused: 'Notificación de pausa de envío masivo',
          resumed: 'Notificación de reanudación de envío masivo'
        }
      },

      system: {
        platform: {
          issues: 'Notificación de error del sistema de la plataforma'
        },

        route: {
          issues: 'Notificación de error del sistema de enrutamiento'
        }
      }
    },

    email: {
      recipients: 'Destinatarios de notificaciones por correo electrónico'
    },

    sms: {
      recipients: 'Destinatarios de notificaciones por SMS'
    }
  },

  integrations: {
    pyrus: {
      credentials: 'Credenciales para conectar con Pyrus'
    }
  },

  reports: {
    maxConcurrentGenerating: 'Número máximo de informes generados simultáneamente'
  }
})

export default {
  title: 'Permisos',

  subtitles: {
    presets: 'Preajustes'
  },

  dialogs: {
    titles: {
      info: 'Información sobre niveles de permisos'
    }
  },

  labels: {
    create: 'Crear',
    check: 'Verificar número',
    finalize: 'Finalizar',
    find: 'Encontrar',
    generate: 'Generar',
    set: 'Establecer',
    get: 'Obtener',
    use: 'Usar',
    getSendingsForTask: 'Obtener envíos para la tarea',
    remove: 'Eliminar',
    update: 'Actualizar',
    modify: 'Modificar',
    seek: 'Buscar',
    download: 'Descargar',
    upload: 'Subir',
    setRead: 'Marcar como leído',
    setPermissions: 'Establecer permisos',
    setRoutingGroups: 'Establecer grupos de enrutamiento',
    setMessageRuleGroups: 'Establecer grupos de reglas de mensajes',
    setSettings: 'Establecer configuraciones',
    setSendernames: 'Establecer nombres de remitentes',
    setPatterns: 'Establecer patrones',
    setTariffs: 'Establecer tarifas',
    showSecrets: 'Mostrar permisos secretos',
    trigger: 'Activar',
    health: 'Rendimiento',
    loginAs: 'Iniciar sesión como',
    request: 'Solicitar',
    controlDocuments: 'Control de documentos',
    edit: 'Editar',
    viewChangelogs: 'Ver lista de cambios',
    contracts: 'Contratos',
    companies: 'Empresas',
    documentTemplates: 'Plantillas de documentos',
    refund: 'Reembolso de pago',
    presetUsersBalance: 'Posibilidad de descargar la lista de usuarios',
    matchKeywords: 'Verificar palabras clave',
    setOtpChannels: 'Establecer canales OTP',
    setHasContract: 'Establecer la existencia de contrato',

    ...messages.es['report-manager'].types,

    ...settingsUser.paths,

    notifications: {
      enabled: 'Notificaciones habilitadas',

      events: notifications.events,
      childrenUsersEvents: notifications.childrenUsersEvents,

      email: {
        recipients: 'Destinatarios de notificaciones por correo electrónico'
      },

      sms: {
        recipients: 'Destinatarios de notificaciones por SMS'
      }
    },

    me: {
      settingsUser: granularCommonLabels
    },

    child: {
      settingsUser: granularCommonLabels
    }
  },

  hints: {
    warning: 'Cambiar permisos no requiere actualizar el usuario.'
  },

  tooltips: {
    info: 'Información sobre niveles de permisos'
  },

  buttons: {
    false: 'Falso',
    me: 'Usuario',
    reseller: 'Revendedor'
  },

  origins: {
    me: 'Propios',
    child: 'Subordinados'
  },

  services: {
    ...messages.es.services,

    referral: 'Programa de referidos',
    integrations: 'Integraciones',
    webhooks: 'Webhooks',
    websocket: 'WebSocket',
    smpp: 'SMPP',
    granular: 'Granulares',
    secret: 'Secretos',

    child: {
      settingsUser: 'Configuraciones de usuarios subordinados'
    },

    me: {
      settingsUser: 'Configuraciones del propio usuario'
    }
  },

  accepts: {
    false: 'Prohíbe cualquier acción que requiera el permiso correspondiente.',
    me: 'Permite acciones con objetos que el usuario creó por sí mismo, o que su revendedor o administrador creó para él.',
    manager: 'Permite acciones con objetos que pertenecen al propio usuario o a los usuarios vinculados al gerente.',
    reseller: 'Permite acciones con objetos que pertenecen al propio usuario o a los usuarios subordinados del revendedor.',
    true: 'Permite acciones con cualquier objeto en el sistema.',
    default: 'Permiso por defecto.',
    read: 'Permite solo la lectura del valor, pero no permite modificarlo.',
    write: 'Permite leer y modificar el valor.'
  },

  snackbars: {
    updated: 'Permiso actualizado con éxito'
  },

  tooltips: {
    accepts: {
      default: 'El permiso para ver o editar esta configuración no ha sido modificado.',
      read: 'Se le permite solo ver el valor.',
      write: 'Se le permite ver y editar el valor.'
    },

    origins: {
      me: 'Los permisos controlan el acceso para ver y editar las propias configuraciones del usuario (encima del esquema base).',
      child: 'Los permisos controlan el acceso para ver y editar las configuraciones de los usuarios subordinados (encima del esquema base).'
    }
  },

  tabs: {
    advanced: 'Avanzado',
    granular: 'Granular',
    secret: 'Secreto'
  }
}
